import { render } from "./TechStackComp.vue?vue&type=template&id=1f3ab66f"
import script from "./TechStackComp.vue?vue&type=script&lang=js"
export * from "./TechStackComp.vue?vue&type=script&lang=js"

import "./TechStackComp.vue?vue&type=style&index=0&id=1f3ab66f&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__